import React from 'react';

const Vendor = (props) => (
        <div className="col-all-2">
            <div className="wrapper--item delay--6" data-aos="fade-up">
                <a onClick={event => props.clickHandler(event, props.index)} href={`${process.env.PUBLIC_URL}/`}>
                    <div className="bdr--grad">
                        <div className="proceed-logs">
                            <img src={props.image} alt={props.name}/>
                        </div>
                    </div>
                </a>
                <div className="dealsbox-info"><span>{props.name}</span></div>
            </div>
        </div>
    )

export default Vendor;